"use client"

import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import "./NewDetailManager.css"
import newsService from "../../../services/api/newsService"

export default function AdminNewDetail() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [news, setNews] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState("")

    useEffect(() => {
        const fetchNewsDetail = async () => {
            try {
                setLoading(true)
                const response = await newsService.getNewsById(id)
                console.log('Đã nhận phản hồi từ API chi tiết tin tức:', response)

                // Kiểm tra cấu trúc response và set state
                if (response && response.news) {
                    // Case 1: API trả về dạng { news: { ... } }
                    setNews(response.news)
                } else if (response && response.data) {
                    // Case 2: Service trả về response.data, kiểm tra xem data có phải đối tượng tin tức không
                    // (Kiểm tra đơn giản bằng cách check sự tồn tại của một trường điển hình như title)
                    if (response.data.title) {
                        setNews(response.data)
                    } else {
                        setError("Cấu trúc dữ liệu tin tức không hợp lệ.")
                        setNews(null)
                    }
                } else {
                    setError("Không nhận được dữ liệu tin tức hợp lệ từ API.")
                    setNews(null)
                }

            } catch (error) {
                console.error("Lỗi khi tải thông tin chi tiết tin tức:", error)
                setError("Không thể tải thông tin chi tiết tin tức.")
                setNews(null)
            } finally {
                setLoading(false)
            }
        }

        if (id) {
            fetchNewsDetail()
        } else {
            setError("Không tìm thấy ID tin tức.")
            setLoading(false)
            setNews(null)
        }

    }, [id])

    if (loading) {
        return <div className="loading-spinner">Đang tải...</div>
    }

    if (error) {
        return <div className="error-message">{error}</div>
    }

    if (!news) {
        return (
            <div className="ndm-container">
                <div className="ndm-header">
                    <h1 className="ndm-heading">Chi Tiết Tin Tức</h1>
                    <button className="ndm-back-button" onClick={() => navigate(-1)}>
                        Quay Lại Danh Sách
                    </button>
                </div>
                <div className="no-news-found">Không tìm thấy tin tức.</div>
            </div>
        )
    }

    return (
        <div className="ndm-container">
            <div className="ndm-header">
                <h1 className="ndm-heading">Chi Tiết Tin Tức</h1>
                <button className="ndm-back-button" onClick={() => navigate(-1)}>
                    Quay Lại Danh Sách
                </button>
            </div>
            <div className="ndm-content">
                <div className="ndm-image-section">
                    <img src={news.photo?.[0] || "/placeholder.svg"} alt={`Ảnh ${news.title || 'tin tức'}`} className="ndm-main-image" />
                </div>
                <div className="ndm-info-section">
                    <h2>{news.title}</h2>
                    <p className="ndm-category">Danh mục: {news.new_category?.name || 'Chưa phân loại'}</p>
                    <p className="ndm-date">Ngày đăng: {news.date ? new Date(news.date).toLocaleDateString() : 'Không rõ ngày'}</p>
                    <div className="ndm-description">
                        <h3>Mô tả</h3>
                        <p>{news.description}</p>
                    </div>
                    <div className="ndm-content-full">
                        <h3>Nội dung chi tiết</h3>
                        <p>{news.content}</p>
                    </div>
                </div>
            </div>
        </div>
    )
} 